import { useContext } from 'react';
import { GroupTagsResetContext } from '../Context';

export default function useGroupTagsReset() {
  const value = useContext(GroupTagsResetContext);
  return value;
}

export { useGroupTagsReset };